export default __webpack_public_path__ + "static/media/chidi.f0620258.JPG";